import { Component, EventEmitter, OnChanges, OnInit } from '@angular/core';
import { ScaffoldSidebarRef } from '@app/framework/sidebar/scaffold-sidebar.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

export enum RetryServices {
  zip = 'ZipService',
  zipWithFilesAndFolders = 'ZipWithFilesAndFolders',
  courseImport = 'CourseImportService',
  viewSync = 'ViewSync',
}

export enum NotificationMessageIcon {
  checkmark = 'checkmark',
  fileExport = 'fileExport',
  fileZip = 'fileZip',
  fail = 'fail',
  email = 'email',
}

export interface NotificationMessageData {
  date?: Date;
  text: string;
  link?: { text: string; href: string };
  progress?: number | string;
  id?: any;
  shouldForceOpen?: boolean;
  preventRemoval?: boolean;
  isOld?: boolean;
  status?: string;
  action?: any;
  actionText?: string;
  icon: NotificationMessageIcon;
  retry?: {
    text?: string;
    service: RetryServices;
    data?: any;
  };
}

@Component({
    selector: 'app-notification-sidebar',
    templateUrl: './notification-sidebar.component.html',
    styleUrls: ['./notification-sidebar.component.scss'],
    standalone: false
})
export class NotificationSidebarComponent implements OnInit {
  closeSingleNotification = new EventEmitter();
  closeAllNotifications = new EventEmitter();

  newMessages = [];
  oldMessages = [];
  messages;
  messages$;

  constructor(private sidebarRef: ScaffoldSidebarRef) {}

  ngOnInit(): void {
    this.messages$ = this.messages.pipe(
      tap(({ oldMessages, newMessages }: any) => {
        this.oldMessages =
          Object.keys(oldMessages)
            .map(message => oldMessages[message])
            .sort(this.sortByTime) || [];
        this.newMessages = Object.keys(newMessages).map(
          message => newMessages[message]
        );
      })
    );
  }

  clearAll() {
    this.closeAllNotifications.emit();
  }

  sortByTime(a, b) {
    const val1 = new Date(a.date as string);
    const val2 = new Date(b.date as string);

    return val2 < val1 ? -1 : val2 == val1 ? 0 : 1;
  }

  close() {
    this.sidebarRef.close();
  }

  closeNotification(notification) {
    this.closeSingleNotification.emit(notification);
  }
}
